import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';

export interface ExternalChannelCompleteAddressLeaveHandler {
  handleLeaveWithoutCompletion(): void;
}

@Injectable({
  providedIn: 'root',
})
export class ExternalChannelCompleteAddressLeaveGuard
  implements CanDeactivate<ExternalChannelCompleteAddressLeaveHandler>
{
  canDeactivate(
    component: ExternalChannelCompleteAddressLeaveHandler
  ): boolean {
    component.handleLeaveWithoutCompletion();
    return true;
  }
}
